import { render, staticRenderFns } from "./NavigationControls.vue?vue&type=template&id=2b9309d2&scoped=true"
import script from "./NavigationControls.vue?vue&type=script&lang=js"
export * from "./NavigationControls.vue?vue&type=script&lang=js"
import style0 from "./NavigationControls.vue?vue&type=style&index=0&id=2b9309d2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9309d2",
  null
  
)

export default component.exports